
import { Vue, Component } from "vue-property-decorator";

@Component
export default class UploadProof extends Vue {
  private imageUrl: string = "";
  private imgSrc: string = "";
  private m: string = "";
  private muid: number = 0;
  private loading: boolean = false;

  created() {
    const { m } = this.$route.query;
    this.m = String(m);
    this.GetSignMeetingUserByMu();
  }

  /**
   * @title 上传图片
   * @date 2020-03-01
   */
  async UploaderImg(ev: any) {
    this.loading = true;
    let _imgUrl = ev.target.files[0];
    let formdata = new FormData();
    formdata.append("file", _imgUrl);
    formdata.append("path", ev.target.value);
    try {
      let Res = await this.$http.personalCenter.UploadPic(formdata);
      if (Res.Code === 1000) {
        let params = {
          m: this.m,
          muid: this.muid,
          vouchimg: String(Res.Msg),
        };
        let _res = await this.$http.personalCenter.EditUserVouch(params);
        console.log(_res);
        if (_res.Code === 1000) {
          this.GetSignMeetingUserByMu();
          this.$message({ message: "上传成功！", type: "success" });
        } else {
          VUE.$message.error({ message: "上传失败！", customClass: "errorMessage" });
        }
      }
      this.loading = false;
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * @title 获取当前登录账户报名信息接口
   * @date 2020-03-01
   */
  async GetSignMeetingUserByMu() {
    let params = {
      m: this.m,
    };
    let _userInfoRes = await this.$http.SignUp.GetSignMeetingUserByMu(params);
    console.log("_userInfoRes", _userInfoRes);
    if (_userInfoRes.Code === 1000) {
      let { muid, remvoucher } = _userInfoRes.CurUserEntity;
      this.muid = Number(muid);
      this.imgSrc = remvoucher;
    }
  }
}
